export default __webpack_public_path__ + "static/media/vi_Videos.cec6487a.mp4";